import axios from "axios";

export const API_BASE = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({ baseURL: `${API_BASE}/api` });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("fj_admin_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const formatApiError = (e) => {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Something went wrong";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d.msg || String(d);
};

export const sendInquiry = (type, data) => api.post("/inquiries", { type, data });

const bdt = (n) => "৳ " + Number(n || 0).toLocaleString("en-IN");
export const formatPrice = (item) => (item.currency === "BDT" ? bdt(item.price) : "$" + Number(item.price || 0).toLocaleString());
